





















import { Component, Vue } from 'vue-property-decorator';
import Config from './../../config';

const config = Config.getInstance();

@Component({})
export default class SocialAuth extends Vue {
  facebookLink = `${config.authServiceUrl}/api/auth/facebook?callbackUrl=${encodeURI(config.learnServiceUrl)}`;

  linkedinLink = `${config.authServiceUrl}/api/auth/linkedin?callbackUrl=${encodeURI(config.learnServiceUrl)}`;

  googleLink = `${config.authServiceUrl}/api/auth/google?callbackUrl=${encodeURI(config.learnServiceUrl)}`;
}
